export const createChatMessage = (text, sender, extra = {}) => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  text,
  sender,
  timestamp: new Date().toISOString(),
  ...extra,
});

export const formatChatTime = (date) => {
  try {
    return new Date(date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
};

export const renderChatMarkdownLite = (text) => {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={i} className="font-semibold">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <span key={i}>{part}</span>;
  });
};

export const buildChatHistory = (msgs) =>
  msgs
    .filter((m) => m.sender === 'user' || m.sender === 'bot')
    .filter((m) => !m.isWelcome)
    .slice(-20)
    .map((m) => ({
      role: m.sender === 'user' ? 'user' : 'assistant',
      text: m.text,
    }));

export const loadStoredChat = (storageKey, fallbackMessage) => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed.map((m) => ({
          ...m,
          timestamp: m.timestamp || new Date().toISOString(),
        }));
      }
    }
  } catch {
    /* ignore */
  }
  return [createChatMessage(fallbackMessage, 'bot', { isWelcome: true })];
};

export const persistChat = (storageKey, messages) => {
  if (!storageKey || messages.length === 0) return;
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(messages.slice(-40)));
  } catch {
    /* ignore */
  }
};
